import styles from './PhoneNumberField.css'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

class PhoneNumberField extends React.Component {
  render () {
    let {input, meta, type, placeholder, showTextError} = this.props
    let {touched, error} = meta
    return (
      <div className={styles['field-wrapper']} id='phone-number-field'>
        <div className={styles['input-icon']}>
          <img src={require('./flag-icon.png')} className={styles.flag} />
          +62
        </div>
        <input {...input}
          type={type}
          placeholder={placeholder}
          className={
            !touched
            ? `form-control ${styles['input-field']}`
            : error
              ? `form-control ${styles['input-field']} ${!showTextError && `${styles['has-error']}`}`
              : `form-control ${styles['input-field']} ${!showTextError && `${styles['has-success']}`}`
          }
          maxLength='12'
          onChange={this._onChange} />

        {showTextError && <small className='error'>{touched ? error : ''}</small>}
        {!showTextError && touched && error &&
          <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip'>{error}</Tooltip>}>
            <span
              className={'form-control-feedback glyphicon glyphicon-remove'}
              style={{'pointer-events': 'auto', 'cursor': 'pointer'}}
                />
          </OverlayTrigger>
        }
        {!showTextError && touched && !error &&
          <span className={'form-control-feedback glyphicon glyphicon-ok'} />
        }
      </div>
    )
  }

  _onChange = (e) => {
    const nextVal = e.target.value
    const {input: {onChange}} = this.props
    if (!isNaN(nextVal) && (nextVal[0] !== '0') && (nextVal[0] !== '6') && (nextVal[0] !== '+') && (nextVal[0] !== '-') && (!/\s/g.test(nextVal)) && (!/\./g.test(nextVal))) {
      onChange(e, nextVal)
    }
  }
}

export default PhoneNumberField



// WEBPACK FOOTER //
// ./app/components/Fields/ReduxForm/PhoneNumberField/PhoneNumberField.js